import React from 'react';
import { useState, useEffect, FunctionComponent } from "react"
import Input from "@murphy-frontend/web-core/components/Input"
import OptionSet from "@murphy-frontend/web-core/components/OptionSet"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import { dashboardNameIsValid } from "@murphy-frontend/common/validation"
import { useGetDashboardTemplates } from "../../../common/api/Dashboards/queries"
import { useModal } from "@murphy-frontend/web-core/contexts/ModalContext"
import { useUserPreferences } from "../../../common/contexts/UserPreferencesContext"
import { ModalConfiguration } from "@murphy-frontend/web-core/components/Modal"
import { useCustomer } from "../../../common/contexts/CustomerContext"

const styles = {
    row: {
        display: 'flex',
        width: '80rem',
        marginBottom: 20,
    },
    label: {
        width: '10rem',
        color: '#626262'
    },
    required: {
        width: '10rem',
        color: '#626262',
        fontSize: 10,
        fontStyle: 'italic'
    },
    input: {
        borderWidth: 1,
        borderColor: '#EBEBEB',
        borderStyle: 'solid',
        borderRadius: 5,
        width: '60rem'
    }
}

interface DashboardProps {
    dashboardName: string;
    setDashboardName: void;
    selectedTemplateId: any;
    setSelectedTemplateId: void;
    isEditMode: boolean;
    setSelectedTemplateName: string;
    currentScreenSize: any;

}
const NewCrisisInfoTab: FunctionComponent = ({ dashboardName, setDashboardName, selectedTemplateId, setSelectedTemplateId, isEditMode, setSelectedTemplateName,currentScreenSize }: DashboardProps) => {
    const noSelection = "No selection"
    const { customer } = useCustomer()

    const { openModal, closeModal } = useModal()
    const { translations, language } = useUserPreferences()

    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const [templates, setTemplates] = useState([])

    const [dashboardNameErrorMessage, setDashboardNameErrorMessage] = useState("")

    const {
        isLoading: isLoadingDashboardTemplates,
        isError: isErrorDashboardTemplates,
        data: dataDashboardTemplates,
        error: errorDashboardTemplates
    } = useGetDashboardTemplates(customer.Id)

    const onChangeTemplateId = event => {
        setSelectedTemplateName(templates.filter(temp => temp.id === event.target.value)[0]?.value)
        setSelectedTemplateId(event.target.value);
    }


    useEffect(() => {
        if (dataDashboardTemplates) {
            const mappedTemplates = dataDashboardTemplates.map(template => ({
                id: template.TemplateId,
                value: template.TemplateName
            }))

            mappedTemplates.push({
                id: noSelection,
                value: "-------"
            })

            setTemplates(mappedTemplates)
        }
    }, [dataDashboardTemplates])

    const onChangeDashbordName = event => {
        const newVal = event.target.value
        const val = newVal
        if (!newVal) {
            setDashboardNameErrorMessage("")
        } else if (!dashboardNameIsValid(newVal)) {
            setDashboardNameErrorMessage("Dashboard is not valid")
        } else {
            setDashboardNameErrorMessage("")
        }
        setDashboardName(val)
    }

    function ErrorMessage() {
        return <p>{error}</p>
    }

    useEffect(() => {
        if (error) {
            const modalConf: ModalConfiguration = {
                title: "Error",
                body: <ErrorMessage />,
                buttonText: "Ok",
                type: "error",
                okCallback: () => {
                    setError(null)
                }
            }

            openModal(modalConf)
        }
    }, [error])

    if (
        isLoading || isLoadingDashboardTemplates
    ) {
        return <Spinner isGlobal />
    }

    const saveButtonDisabled = !!dashboardNameErrorMessage

    return (
        <div>
            <section className='header-container vertical-aligner'>
                <div className='three' />
            </section>
            <div>
                <div style={styles.row}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={styles.label}>{translations.name}</span>
                        <span style={styles.required}>{translations.required || "required"}</span>
                    </div>
                    <Input
                        val={dashboardName}
                        isRequired
                        handleChange={onChangeDashbordName}
                        errorMessage={dashboardNameErrorMessage}
                        style={styles.input}
                    />
                </div>
                {!isEditMode && <div style={styles.row}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={styles.label}>{translations.template}</span>
                    </div>

                    {/* templates can only be set when creating a new board */}
                    {templates.length > 1 ? (
                        <OptionSet
                            direction='row'
                            key={2}
                            optionSetId={1}
                            options={templates}
                            selectedOption={selectedTemplateId}
                            handleChange={onChangeTemplateId}
                            style={styles.input}
                        />
                    ) : null}
                </div>}

            </div>

        </div>
    )
}

export default NewCrisisInfoTab;
